export default "__VITE_ASSET__DnL_Rf6h__"